<template>
  <div class="container--fluid mt-4 mx-4">
    <template v-if="!showAppointmentFields && !selectedFeatureTrigger">
      <h2 class="mt-6">Warehouse Fields & Forms</h2>
      <p>Manage the fields and forms requested by this warehouse</p>

      <v-row class="my-6">
        <v-col cols="8">
          <v-expansion-panels accordion>
            <v-expansion-panel readonly>
              <v-expansion-panel-header>
                <h4>Appointment fields</h4>
                <template v-slot:actions>
                  <v-btn
                    small
                    depressed
                    @click="showAppointmentFields = true"
                    data-testid="appointment-fields">
                    Manage this form <v-icon small class="ml-2">mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
              </v-expansion-panel-header>
            </v-expansion-panel>
            <v-expansion-panel v-for="[_, feature] of features" v-bind:key="feature">
              <v-expansion-panel-header>
                <h4>
                  {{ novaCore.upperFirst(feature) }} Form
                  <v-chip class="ml-2" color="primary" x-small>NEW</v-chip>
                </h4>
              </v-expansion-panel-header>
              <v-divider></v-divider>
              <v-expansion-panel-content>
                <custom-forms-feature
                  :warehouse="warehouse"
                  :feature="feature"
                  :triggers="featureTriggers(feature)"
                  @manage="manageFeatureTrigger" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </template>
    <template v-if="showAppointmentFields">
      <appointment-fields :warehouse="warehouse" @back="() => (showAppointmentFields = false)">
      </appointment-fields>
    </template>
    <template v-if="selectedFeatureTrigger?.id">
      <custom-forms-trigger
        :warehouse="warehouse"
        :trigger="selectedFeatureTrigger"
        @back="() => (selectedFeatureTrigger = null)">
      </custom-forms-trigger>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  computed: {
    features() {
      return Object.entries(this.novaCore.CustomFormsFeatures);
    }
  },
  data() {
    return {
      showAppointmentFields: false,
      selectedFeatureTrigger: null,
      warehouseTriggers: []
    };
  },
  methods: {
    manageFeatureTrigger(trigger) {
      this.showAppointmentFields = false;
      this.selectedFeatureTrigger = trigger;
    },
    async getWarehouseTriggers() {
      if (!this.warehouse.id) {
        return;
      }
      const response = await axios.get('custom-forms/trigger', {
        params: {
          s: { objectId: this.warehouse.id, entityName: 'warehouse' },
          limit: 100
        }
      });

      // Full join structure
      // trigger: { flow: { fromFrom: { formFields: [{ field: customField }] } } }

      this.warehouseTriggers = response?.data?.data || [];
    },
    featureTriggers(feature) {
      return this.warehouseTriggers.filter(trigger => trigger.feature === feature);
    }
  },
  beforeMount() {
    this.getWarehouseTriggers();
  }
};
</script>
